import { QUERY_KEYS } from 'api/query-keys';
import { workTemplateService } from 'ogp/services';
import { useMutation, UseMutationOptions } from 'react-query';
import { useInvalidateQuery } from 'shared/hooks/query-hooks/useInvalidateQuery';

type WorkTemplateMutationOptions = UseMutationOptions<unknown, unknown, string>;

export const useArchiveWorkTemplate = (options?: WorkTemplateMutationOptions) => {
  const mutationFn = async (workTemplateId: string) =>
    await workTemplateService.archiveWorkTemplate(workTemplateId);
  const invalidateQuery = useInvalidateQuery();
  const mutationOptions: WorkTemplateMutationOptions = {
    onSettled: () => {
      invalidateQuery(QUERY_KEYS.workTemplates());
    },
    ...options,
  };

  return useMutation(mutationFn, mutationOptions);
};
